<template>
    <main-template>
      <div>
      <div class="loading-overlay" v-if="fullPageLoadingCount > 0 ">
        <div class="lottie-container">
          <Vue3Lottie
            :animationData="loadingAnimation"
            :height="200"
            :width="200"
            :loop="true"
            :speed="2"
            :autoPlay="true"
          />
        </div>
      </div>
    </div>
    </main-template>
  </template>

  <script setup lang="ts">
  import { computed } from 'vue'
  import loadingAnimation from '../assets/lottiefiles/loadingAnimation.json'
  import { useStore } from 'vuex'
  import { Vue3Lottie } from 'vue3-lottie'

  const store = useStore()

  const fullPageLoadingCount = computed(() => store.getters['fnol/getFullPageLoadingCount'])

  defineExpose({ fullPageLoadingCount })
  </script>

  <style scoped>
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }

  .lottie-container {
    width: 150px;
    height: 150px;
  }
  </style>
